import {AddressType} from 'desktop/types/addressType';

/**
 * Set form values as valid, because it has been validated with Zod
 */
export function setFieldsAsValid(formValues: AddressType) {
    const result = {...formValues};
    Object.keys(formValues).forEach(field => {
        result[field as keyof AddressType] = {
            ...result[field as keyof AddressType],
            error: false,
            success: true,
        };
    });
    return result;
}
